import React from "react";
import CountUp from "react-countup";

const BugBountyCard = ({ title, prize, email, detail, date }) => {
  const newDate = new Date(date).toString().split(" ");
  const dateString = `${newDate[1]} ${newDate[2]}, ${newDate[3]}, ${newDate[4]}`;
  return (
    <>
      <div className="w-full flex flex-col justify-between">
        <div className="flex justify-evenly flex-col md:flex-row mt-8">
          <div className="">
            <div className="space-y-4 text-white">
              <div className="flex flex-col items-center justify-between px-[5em] pb-5 pt-2">
                <div className="block px-6 py-4 bg-black/50 rounded-t-2xl border border-black/20 shadow-md cursor-pointer w-[24em] sm:w-[30em] xl:w-[35em] ">
                  <div className="flex justify-between items-center">
                    <p className="text-lyellow text-sm md:text-xl font-semibold">
                      {title}
                    </p>
                    <p className="text-lyellow text-sm sm:text-md">
                      {date ? dateString : "Coming Soon"}
                    </p>
                  </div>
                </div>

                <div className="block p-6 bg-[#2a3137] border border-black/20 shadow-md cursor-pointer w-[24em] sm:w-[30em] xl:w-[35em] ">
                  <div className="flex flex-col justify-center space-y-5">
                    <div className="flex justify-start items-center">
                      <p className="text-lyellow text-xl font-semibold">
                        Prize

                      </p>
                      <div className="pl-20 text-2xl">
                        <CountUp
                          separator=","
                          prefix="~$"
                          suffix=" "
                          end={prize}
                        />
                      </div>
                    </div>
                    <div className="flex justify-start items-center">
                      <p className="text-lyellow text-xl font-semibold">
                        Contact
                      </p>
                      <button className="ml-14 bg-lyellow text-sm font-semibold py-2 px-4 hover:bg-[#1d2226] text-black hover:text-white transition ease-in duration-200 rounded-lg">
                        <a href={`mailto:${email}`}>Contact</a>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="block p-6 bg-black/40 rounded-b-2xl border border-black/20 shadow-md mb-10 cursor-pointer w-[24em] sm:w-[30em] xl:w-[35em] ">
                  <div className="flex flex-col justify-center space-y-1">
                    <p className="font-semibold text-xl text-lyellow">
                      Details:
                    </p>
                    <div>{detail}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BugBountyCard;
